var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9", attrs: { id: "main" } }, [
              _c("div", { staticClass: "container shortcode travel-ideas" }, [
                _c("h1", { staticClass: "idea-title" }, [
                  _vm._m(0),
                  _vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale])),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "booking-information sdr-box" }, [
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_1[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_10[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_20[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_30[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_40[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_50[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_60[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_8[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_61[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_2[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_70[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_71[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_72[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_73[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_74[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_3[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_100[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_110[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_120[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_121[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_122[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_123[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_124[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_125[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_126[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_4[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_140[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_141[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_142[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_41[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_143[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_42[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_144[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_51[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_1441[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_52[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_1442[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_5[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_150[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_6[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_160[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_h4_7[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_170[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_180[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_190[_vm.getCurrentLocale]),
                  },
                }),
                _c("br"),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.covid19_200[_vm.getCurrentLocale]),
                  },
                }),
                _vm._v(" "),
                _c("br"),
                _c("p", [_vm._v("Update: 14.06.2021")]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar col-md-3" },
              [_c("sdr-aboutsundair-box"), _vm._v(" "), _c("sdr-contact-box")],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sdr-promobox"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }